(function () {
  'use strict';

  if (window.Suchebene) return;

  var SCHMAL = '(max-width: 1023px)';

  function schmal() {
    return !!(window.matchMedia && window.matchMedia(SCHMAL).matches);
  }

  var grund = null, kopf = null, titel = null, zurueck = null, offen = null;

  function aufbauen() {
    if (grund) return;

    grund = document.createElement('div');
    grund.className = 'sb-grund';
    grund.hidden = true;
    grund.addEventListener('click', zu);
    document.body.appendChild(grund);

    kopf = document.createElement('div');
    kopf.className = 'sb-kopf';
    kopf.hidden = true;
    document.body.appendChild(kopf);

    titel = document.createElement('p');
    titel.className = 'sb-titel';
    titel.hidden = true;
    document.body.appendChild(titel);

    zurueck = document.createElement('button');
    zurueck.type = 'button';
    zurueck.className = 'sb-zurueck';
    zurueck.innerHTML =
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"'
      + ' stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">'
      + '<path d="M15 5l-7 7 7 7"/></svg>';
    zurueck.addEventListener('click', zu);
    zurueck.hidden = true;
    document.body.appendChild(zurueck);
  }

  function messen() {
    if (!offen) return;
    var r = offen.leiste.getBoundingClientRect();

    offen.liste.style.top = Math.round(r.bottom) + 'px';

    if (kopf) kopf.style.height = Math.round(r.bottom) + 'px';


    if (zurueck) {
      var f = offen.eingabe.getBoundingClientRect();
      zurueck.style.top = Math.round(f.top + f.height / 2) + 'px';
    }

    var vv = window.visualViewport;
    if (!vv) return;
    var kante = r.bottom - vv.offsetTop;
    var platz = Math.round(vv.height - kante - 12);
    offen.liste.style.maxHeight = Math.max(132, platz) + 'px';
  }

  function auf(eintrag) {
    if (offen || !schmal()) return;
    aufbauen();
    offen = eintrag;

    document.body.classList.add('sb-an');
    eintrag.leiste.classList.add('sb-leiste');
    eintrag.liste.classList.add('sb-liste');
    grund.hidden = false;
    kopf.hidden = false;
    titel.hidden = false;
    titel.textContent = eintrag.titel;
    zurueck.hidden = false;
    zurueck.setAttribute('aria-label', eintrag.schliessText);

    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', messen);
      window.visualViewport.addEventListener('scroll', messen);
    }
    messen();

    var stand = (eintrag.eingabe.value || '').trim();
    if (stand) {
      try {
        eintrag.eingabe.dispatchEvent(new Event('input', { bubbles: true }));
      } catch (e) {}
    }
  }

  function zu() {
    if (!offen) return;
    var eintrag = offen;
    offen = null;

    document.body.classList.remove('sb-an');
    eintrag.leiste.classList.remove('sb-leiste');
    eintrag.liste.classList.remove('sb-liste');
    eintrag.liste.style.maxHeight = '';
    eintrag.liste.style.top = '';
    if (grund) grund.hidden = true;
    if (kopf) kopf.hidden = true;
    if (titel) titel.hidden = true;
    if (zurueck) zurueck.hidden = true;

    if (window.visualViewport) {
      window.visualViewport.removeEventListener('resize', messen);
      window.visualViewport.removeEventListener('scroll', messen);
    }

    if (typeof eintrag.zu === 'function') { try { eintrag.zu(); } catch (e) {} }
    try { eintrag.eingabe.blur(); } catch (e) {}
  }

  window.Suchebene = {
    binden: function (opt) {
      if (!opt || !opt.leiste || !opt.eingabe || !opt.liste) return;
      if (opt.eingabe.__sbGebunden) return;
      opt.eingabe.__sbGebunden = true;

      var eintrag = {
        leiste: opt.leiste,
        eingabe: opt.eingabe,
        liste: opt.liste,
        zu: opt.zu,
        schliessText: opt.schliessText || (window.I18N_GLOBAL && window.I18N_GLOBAL.suche_schliessen) || 'Suche schließen',
        titel: opt.titel || 'Monitor suchen'
      };

      var oeffnen = function () { auf(eintrag); };
      opt.eingabe.addEventListener('focus', oeffnen);
      opt.eingabe.addEventListener('click', oeffnen);

      opt.liste.addEventListener('click', function (e) {
        if (offen !== eintrag) return;
        if (!e.target.closest('button, [data-ref], a')) return;
        setTimeout(zu, 0);
      });

      var form = opt.eingabe.form || opt.eingabe.closest('form');
      if (form) {
        form.addEventListener('submit', function () {
          if (offen === eintrag) setTimeout(zu, 0);
        });
      }

      opt.eingabe.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && offen === eintrag) zu();
      });
    },

    messen: messen,
    zu: zu
  };

  if (window.matchMedia) {
    var breit = window.matchMedia('(min-width: 1024px)');
    var horch = function () { if (breit.matches) zu(); };
    if (breit.addEventListener) breit.addEventListener('change', horch);
    else if (breit.addListener) breit.addListener(horch);
  }
})();
